import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';
import type { PrizeTableTooltips, TableRow, TableRowProps } from '../../../../types';
import { MobileRow } from './components';

type MobileTableProps = ComponentProps<'div'> & {
  headers: TableRowProps['headers'];
  data: TableRow[];
  disableFirstRow?: boolean;
  tooltips?: PrizeTableTooltips;
};

function MobileTable({ className, data, headers, disableFirstRow = false, tooltips, ...props }: MobileTableProps) {
  return (
    <div className={twMerge('w-full', className)} {...props}>
      {data.map((row, index) => (
        <MobileRow
          key={index}
          row={row}
          rowIndex={index}
          headers={headers}
          className={disableFirstRow && index === 0 ? 'opacity-40' : ''}
          aria-disabled={disableFirstRow && index === 0}
          tooltips={tooltips?.get(index)}
        />
      ))}
    </div>
  );
}

export { MobileTable };
